import { MissionAssessmentRequestCreateDto } from '@@types/api.types';
import { zCoercedOptional } from '@utils/zodv4.util';
import { z } from 'zod/v4';

// Step 1: Technology Parameters
export const technologyParametersStepSchema = z.object({
  domainId: z.string().min(1, 'Domain is required'),
  technologyId: z.string().min(1, 'Technology is required'),
  useId: z.string().min(1, 'Use is required'),
});

// Step 2: Expert Matching
export const expertMatchingStepSchema = z.object({
  isStrictMatch: z.boolean(),
  message: zCoercedOptional(z.string().trim().optional()),
  veteranCountriesOfService: zCoercedOptional(z.array(z.string().min(1)).optional()),
  veteranServiceIds: zCoercedOptional(z.array(z.string().min(1)).optional()),
});

// Combined schema for full form
export const missionAssessmentRequestSchema = z.object({
  domainId: z.string().min(1, 'Domain is required'),
  isStrictMatch: z.boolean(),
  message: zCoercedOptional(z.string().trim().optional()),
  technologyId: z.string().min(1, 'Technology is required'),
  useId: z.string().min(1, 'Use is required'),
  veteranCountriesOfService: zCoercedOptional(z.array(z.string().min(1)).optional()),
  veteranServiceIds: zCoercedOptional(z.array(z.string().min(1)).optional()),
}) as z.ZodType<MissionAssessmentRequestCreateDto>;

export type MissionAssessmentRequestFormData = z.infer<typeof missionAssessmentRequestSchema>;
